import { combineReducers } from 'redux';

import navBarReducer from './common/navbar';
import userRoleReducer from './common/userRole';
import ApplicationDetailReducer from './application/detail';
import UserLoginReducer from './authentication/login';
import UserSocialLoginReducer from './authentication/socialLogin';
import UserSignupReducer from './authentication/signup';
import UserVerificationCodeReducer from './authentication/verificationCode';
import UserUpdateProfileReducer from './user/updateProfile';
import UserUpdateUsernameReducer from './user/updateUsername';
import UserForgotPasswordReducer from './user/forgotPassword';
import UserResetPasswordReducer from './user/resetPassword';
import UserListReducer from './user/userList';
import GetBalanceReducer from './user/getBalance';
import CheckEmailExistReducer from './user/emailExist';
import CheckUsernameExistReducer from './user/usernameExist';
import ResendVerificationReducer from './user/resendVerification';
import RoleListReducer from './user/roleList';
import AllPlayerReducer from './user/allPlayer';
import CashinRapydReducer from './cashIn/rapyd';
import CashinRapydCallbackReducer from './cashIn/rapydCallback';
import CashinRapydFeeReducer from './cashIn/rapydFee';
import TransactionHistoryReducer from './common/transactionHistory';
import CashinRapydMethodsReducer from './cashIn/rapydMethods';
import NewsletterReducer from './common/newsletter';
import GameListReducer from './game/list';
import GameImageReducer from './game/gameImage';
import TournamentsReducer from './tournament/list';
import CreateTournamentReducer from './tournament/createTournament';
import CancelTournamentReducer from './tournament/cancelTournament';
import CreateMatchReducer from './match/createMatch';
import AcceptInviteReducer from './match/acceptInvite';
import AcceptJoinReducer from './match/acceptJoin';
import DeclineInviteReducer from './match/declineInvite';
import ForfeitReducer from './match/forfeit';
import JoinReducer from './match/join';
import MatchPercentageReducer from './match/matchPercentage';
import RejectJoinReducer from './match/rejectJoin';
import WithdrawReducer from './match/withdraw';
import GetOpenMatchReducer from './match/openMatch';
import GetPendingMatchReducer from './match/pendingMatch';
import GetMatchHistoryReducer from './match/matchHistory';
import MatchDetailsReducer from './match/details';
import PlayMatchReducer from './match/play';
import ActiveTournamentReducer from './match/activeTournament';
import SearchUserReducer from './admin/searchUser';
import AdminManageRoleReducer from './admin/manageRole';
import BanUserReducer from './admin/banUser';
import DeleteUserReducer from './admin/deleteUser';
import AddFundReducer from './admin/addFund';
import NotificationListReducer from './notification/notificationList';
import NotificationDetailReducer from './notification/notificationDetail';
import NotificationReadReducer from './notification/notificationRead';
import DashboardDetailReducer from './dashboard/dashboardDetail';
import NavigationCountReducer from './dashboard/getNavigationCount';
import UserDetailsReducer from './admin/userDetails';
import removeBanUserReducer from './admin/removeBanUser';
import TournamentListReducer from './admin/tournamentList';
import TournamentsDetailsReducer from './tournament/details';
import UpdateRoleReducer from './admin/updateRole';
import GameDeveloperListReducer from './game/listGameDeveloper';
import AddGameDeveloperReducer from './game/addGameDeveloper';
import UpdateGameDeveloperReducer from './game/updateGameDeveloper';
import DetailGameDeveloperReducer from './game/detailGameDeveloper';
import PrizeDistributionReducer from './tournament/prizeDistribution';
import CalculationEarningReducer from './tournament/calculationEarning';
import MatchHistoryDetailReducer from './match/matchHistoryDetail';
import MatchUsernameReducer from './match/matchUsername';
import PlayTournamentReducer from './tournament/play';
import AdminCreateTournamentReducer from './admin/createTournament';
import LogOutDetailReducer from './user/logOutDetail';
import HistoryTournamentsReducer from './tournament/historyTournamentList';
import HistoryTournamentsDetailsReducer from './tournament/historyTournamentDetail';
import { EntityStoreName, StoreName } from '../../app/enums/store';
import { modalsState } from '../../app/store/modal/slice';
import { gamesState } from '../../modules/games/store/games/slice';
import { sessionState } from '../../app/store/session/slice';
import { persistReducer } from 'redux-persist';
// TODO: check if local storage storage (persist) works fine with other local storage activity
import storage from 'redux-persist/lib/storage';
import { currentMatchState } from '../../modules/matches/store/current-match/slice';
import { matchesState } from '../../modules/matches/store/matches/slice';
import { usersState } from '../../modules/users/store/users/slice';
import { tournamentsState } from '../../modules/tournaments/store/tournaments/slice';
import { currentTournamentState } from '../../modules/tournaments/store/current-tournament/slice';
import { notificationsState } from '../../modules/notifications/store/notifications/slice';
import { searchUsersState } from '../../modules/users/store/search-users/slice';
import { manageUsersState } from '../../modules/admin/store/manage-users/slice';
import { manageWithdrawState } from '../../modules/admin/store/manage-withdraw/slice';
import { platformLinkingState } from '../../modules/platform-linking/store/slice';
import { tournamentBracketState } from '../../modules/bracket/store/slice';
import { currentTournamentMatchGameState } from '../../modules/tournaments/store/current-tournament-match-game/slice';
import { walletState } from '../../modules/payments/store/wallet/slice';
import { transactionsHistoryState } from 'modules/payments/store/transactions/slice';
import { feedbackState } from '../../modules/feedback/store/slice';
import { userBalancesState } from 'modules/payments/store/user-payment-accounts/slice';
import { exchangeRatesState } from 'modules/payments/store/exchange-rates/slice';
import { gameStatisticsState } from 'modules/game-statistics/store/slice';
import { gameSessionsState } from 'modules/game-sessions/store/game-sessions/slice';
import { tournamentActivityState } from '../../modules/tournament-activity/store/slice';
import {affiliateProgramsState} from "../../modules/affiliate-programs/store/slice";

const sessionReducer = persistReducer(
  {
    key: StoreName.Session,
    storage,
  },
  sessionState.reducer
);

const platformLinkingReducer = persistReducer(
  {
    key: EntityStoreName.PlatformLinking,
    storage,
  },
  platformLinkingState.reducer
);

export const rootReducer = combineReducers({
  // TODO: Remove all old reducers!!!
  navBar: navBarReducer,
  applicationDetail: ApplicationDetailReducer,
  userRole: userRoleReducer,

  userSignup: UserSignupReducer,
  userLogin: UserLoginReducer,
  userSocialLogin: UserSocialLoginReducer,
  userVerificationCode: UserVerificationCodeReducer,
  userUpdateProfile: UserUpdateProfileReducer,
  userUpdateUsername: UserUpdateUsernameReducer,
  userForgotPassword: UserForgotPasswordReducer,
  userResetPassword: UserResetPasswordReducer,
  userList: UserListReducer,
  getBalance: GetBalanceReducer,
  roleList: RoleListReducer,
  emailExist: CheckEmailExistReducer,
  usernameExist: CheckUsernameExistReducer,
  resendVerification: ResendVerificationReducer,
  allPlayerList: AllPlayerReducer,
  logOutDetailReducer: LogOutDetailReducer,

  cashinRapyd: CashinRapydReducer,
  cashinRapydCallback: CashinRapydCallbackReducer,
  cashinRapydFee: CashinRapydFeeReducer,
  cashinRapydMethods: CashinRapydMethodsReducer,
  transactionHistory: TransactionHistoryReducer,

  newsletter: NewsletterReducer,

  gameList: GameListReducer,
  gameImage: GameImageReducer,
  gameDeveloperList: GameDeveloperListReducer,
  addGameDeveloper: AddGameDeveloperReducer,
  updateGameDeveloper: UpdateGameDeveloperReducer,
  detailGameDeveloper: DetailGameDeveloperReducer,

  createMatch: CreateMatchReducer,
  acceptInvite: AcceptInviteReducer,
  acceptJoin: AcceptJoinReducer,
  declineInvite: DeclineInviteReducer,
  forfeit: ForfeitReducer,
  join: JoinReducer,
  matchPercentage: MatchPercentageReducer,
  rejectJoin: RejectJoinReducer,
  withdraw: WithdrawReducer,
  openMatch: GetOpenMatchReducer,
  pendingMatch: GetPendingMatchReducer,
  matchHistory: GetMatchHistoryReducer,
  matchDetails: MatchDetailsReducer,
  playMatch: PlayMatchReducer,
  matchHistoryDetail: MatchHistoryDetailReducer,
  matchUsername: MatchUsernameReducer,
  activeTournament: ActiveTournamentReducer,

  tournamentsList: TournamentsReducer,
  createTournament: CreateTournamentReducer,
  cancelTournament: CancelTournamentReducer,
  tournamentsDetail: TournamentsDetailsReducer,
  prizeDistributionData: PrizeDistributionReducer,
  calculationEarningData: CalculationEarningReducer,
  playTournament: PlayTournamentReducer,
  historyTournament: HistoryTournamentsReducer,
  historyTournamentsDetails: HistoryTournamentsDetailsReducer,

  searchUser: SearchUserReducer,
  manageRole: AdminManageRoleReducer,
  banUser: BanUserReducer,
  removeBanUser: removeBanUserReducer,
  deleteUser: DeleteUserReducer,
  addFund: AddFundReducer,
  userDetails: UserDetailsReducer,
  tournamentList: TournamentListReducer,
  updateRole: UpdateRoleReducer,
  adminCreateTournament: AdminCreateTournamentReducer,

  notificationList: NotificationListReducer,
  notificationDetail: NotificationDetailReducer,
  notificationRead: NotificationReadReducer,

  dashboardDetail: DashboardDetailReducer,
  navigationCount: NavigationCountReducer,
  [EntityStoreName.Users]: usersState.reducer,
  [EntityStoreName.SearchUsers]: searchUsersState.reducer,
  [EntityStoreName.Games]: gamesState.reducer,
  [EntityStoreName.Matches]: matchesState.reducer,
  [EntityStoreName.CurrentMatch]: currentMatchState.reducer,
  [EntityStoreName.Modals]: modalsState.reducer,
  [EntityStoreName.Tournaments]: tournamentsState.reducer,
  [EntityStoreName.CurrentTournament]: currentTournamentState.reducer,
  [EntityStoreName.CurrentTournamentMatchGame]: currentTournamentMatchGameState.reducer,
  [EntityStoreName.TournamentBracket]: tournamentBracketState.reducer,
  [EntityStoreName.Notifications]: notificationsState.reducer,
  [EntityStoreName.ManageUsers]: manageUsersState.reducer,
  [EntityStoreName.ManageWithdraw]: manageWithdrawState.reducer,
  [EntityStoreName.Feedbacks]: feedbackState.reducer,
  [EntityStoreName.Wallet]: walletState.reducer,
  [EntityStoreName.Transactions]: transactionsHistoryState.reducer,
  [EntityStoreName.UserPaymentAccounts]: userBalancesState.reducer,
  [EntityStoreName.ExchangeRates]: exchangeRatesState.reducer,
  [EntityStoreName.PlatformLinking]: platformLinkingReducer,
  [EntityStoreName.GameStatistics]: gameStatisticsState.reducer,
  [EntityStoreName.TournamentActivity]: tournamentActivityState.reducer,
  [StoreName.Session]: sessionReducer,
  [EntityStoreName.GameSessions]: gameSessionsState.reducer,
  [EntityStoreName.AffiliatePrograms]: affiliateProgramsState.reducer,
});
